import { Theme } from "@mui/material";
import { palettes } from "../themes/palletes";
export const flexRowCont = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyItems: "center",
};

export const actionCont = {
  width: "100%",
  py: "10px",
  px: "10px",
  borderRadius: "14px",
  backgroundColor: palettes.$noticeSubtle,

  grid: {
    ...flexRowCont,
  },

  icon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "48px",
    height: "48px",
    fontSize: "48px",
  },

  fieldCont: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
    px: "10px",
  },

  saveButton: {
    ml: "20px",
    color: "white",
    backgroundColor: "primary.main",
    borderRadius: "12px",
    height: "40px",
    width: "40px",
    ":hover": {
      backgroundColor: "secondary.main",
    },
  },

  filter: {
    "& .MuiSelect-select span::before": {
      content: "'Select Role'",
      display: "flex",
      color: "text.secondary",
      height: "0px",
    },
    background: "white",
    borderRadius: "6px",
    minWidth: "266px",
  },

  filterMenu: {
    htmlInput: {
      MenuProps: {
        MenuListProps: {
          sx: (theme: Theme) => ({
            border: `1px solid ${theme.palette.text.secondary}`,
            borderRadius: "5px",
          }),
        },
      },
    },
  },
};
